module.exports = require('./lib/static/prefixAll')



//////////////////
// WEBPACK FOOTER
// ./~/styled-components/~/inline-style-prefixer/static.js
// module id = 1069
// module chunks = 0